import { BlockTypes } from './Blocks/constants';

export const blocksWithoutContent = [
  BlockTypes.Experts,
  BlockTypes.RecommendedArticles,
  BlockTypes.SubscribeMatrix,
];
